import React from "react";

function InfoCircle() {
  return (
    <svg
      width="88px"
      height="88px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <g id="SVGRepo_iconCarrier">
        {" "}
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="#849be7"
          strokeWidth="1.5"
        />{" "}
        <path
          d="M12 17V11"
          stroke="#849be7"
          strokeWidth="1.5"
          strokeLinecap="round"
        />{" "}
        <circle
          cx="1"
          cy="1"
          r="1"
          transform="matrix(1 0 0 -1 11 9)"
          fill="#849be7"
        />{" "}
      </g>
    </svg>
  );
}

export default InfoCircle;
